import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";
import ColorDot from "../ColorDot";

import styles from "./StatusIndicator.module.css";

type NativeButtonProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "icon">;

interface Props extends NativeButtonProps {
    label?: string;
    color?: string;
    variant?: "default" | "clickable";
    compact?: boolean;
}

function StatusIndicator({
    class: cssClass,
    label,
    color,
    variant = "default",
    compact,
    ...nativeButtonProps
}: Props) {
    return (
        <button
            {...nativeButtonProps}
            class={classname(styles.statusIndicator, cssClass, {
                [styles.clickable]: variant === "clickable",
                [styles.compact]: compact
            })}>
            <ColorDot class={classname(styles.colorDot)} color={color}/>
            <span class={classname("caption-1 medium", styles.label)}>{label}</span>
        </button>
    );
}

export default StatusIndicator;
